"use strict";
/**
 * Created by marek.bogdanovic on 04/10/2016.
 *            ewa.podrazka on 24/10/2016
 *            dominika.grabowska on 22/09/2017
 */
var PreLoader = {
    /**
     * Options
     */
    opts: {
        selectorId: 'bss-overlay-start',
        selector: 'bss-entity-overlay',
        containerId: 'entity',
        triggerActive: 'is-active',
        containerInit: 'is-initialized',
    },
    /**
     * Status of loader
     */
    running: null,
    /**
     * Method for initialize loader
     */
    init: function () {
        this.$element = document.getElementById(this.opts.selectorId);
        this.$container = document.getElementById(this.opts.containerId);
        if (!this.$element) {
            this.$element = document.createElement('div');
            this.$element.id = this.opts.selectorId;
            this.$element.className = this.opts.selector;
            this.$element.innerHTML = "\n          <div class=\"bss-fixed-pointer\">\n              <span class=\"bss-entity-loader\"></span>\n          <div>";
            document.getElementById(this.opts.containerId).appendChild(this.$element);
        }
        if (this.$container.classList.contains(this.opts.containerInit)) {
            this.removeSelector();
        }
        else {
            this.addSelector();
        }
        this.running = true;
    },
    /**
     * Method to stop
     */
    stop: function () {
        this.removeSelector();
        this.running = null;
    },
    /**
     * Method to add class: is-active
     */
    addSelector: function () {
        this.$element.classList.add(this.opts.triggerActive);
    },
    /**
     * Method to remove div
     */
    removeSelector: function () {
        if (this.$element.parentNode) {
            this.$element.parentNode.removeChild(this.$element);
        }
    },
};
window.PreLoader = PreLoader;
